<template>
  <footer id="page-footer">
    <div class="container">

      <div class="footer-logo-and-copy">
        <img src="~assets/images/bg/logo-4.png" alt="">
        <p>©{{ new Date().getFullYear() }}, EON, United Group</p>
      </div>

      <a href="https://united.cloud" class="powered-by" target="_blank">
        <img src="~assets/images/bg/united-logo-2.png" alt="">
      </a>

    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="scss">
@import 'uc/_variables';

#page-footer {
    height: 98px;

    text-align: center;
    background-color: rgb(50, 62, 67);

    &:before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 100%;
    }
    & > .container {
        display: inline-block;
        vertical-align: middle;
        text-align: left;
        position: relative;
    }
}
.footer-logo-and-copy {
    display: inline-block;
    margin-left: 5px;

    img {
        display: inline-block;
        vertical-align: middle;
        width: 27px;
        margin-right: 10px;
    }
    p {
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 0;
        font-size: 12px;
        color: rgb(193, 193, 193);
    }
}
.powered-by {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
    width: 110px;

    img {
        display: block;
        max-width: 100%;
    }
}

@media only screen and (min-width: $breakpoint3) {
    #page-footer {
        height: $footerheight;
    }
    .footer-logo-and-copy {
        margin-left: 10px;

        p {
            font-size: 15px;
        }
    }
    .powered-by {
        right: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue